import { Target, Eye, Lightbulb } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "next-i18next";
import Image from "next/image";

const AboutIcon = "/icons/about_us.png";
const VisionIcon = "/icons/vision.png";
const MissionIcon = "/icons/mission.png";

const sections = [
  {
    id: "about",
    icon: AboutIcon,
    translationKey: "about:about.content",
    fallbackKey: "common:about_p1",
    titleKey: "about:about.title",
  },
  {
    id: "vision",
    icon: VisionIcon,
    translationKey: "about:vision.content",
    fallbackKey: "common:about_p2",
    titleKey: "about:vision.title",
  },
  {
    id: "mission",
    icon: MissionIcon,
    translationKey: "about:mission.content",
    fallbackKey: "common:about_p4",
    titleKey: "about:mission.title",
  },
];

const CompanyMission = () => {
  const { t } = useTranslation(['about', 'common']);

  return (
    <motion.section
      className="py-20 md:py-24 bg-background"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, margin: "-50px" }}
    >
      <div className="container mx-auto px-6">
        <motion.div
          className="text-center mb-16 md:mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            {t("about:section_title", { defaultValue: t("common:about_title") })}
          </h2>
        </motion.div>

        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
          {sections.map((section, index) => (
            <motion.div
              key={section.id}
              className="bg-container-background border border-border rounded-2xl p-8 light_effect_card overflow-hidden relative flex flex-col"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              {/* Icon at top */}
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-container-background border border-border rounded-full flex items-center justify-center relative overflow-hidden light_effect_circular">
                  <Image
                    width={48}
                    height={48}
                    className="w-12 dark:invert-0 invert"
                    src={section.icon}
                    alt={section.id}
                  />
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl md:text-2xl font-bold mb-4 text-center capitalize">
                {t(section.titleKey, { defaultValue: section.id })}
              </h3>

              {/* Content */}
              <div className="text-center">
                <p className="text-base md:text-lg text-secondary-foreground leading-relaxed">
                  {t(section.translationKey, { defaultValue: t(section.fallbackKey) })}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default CompanyMission;
